import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'v2-card-subheader',
  templateUrl: 'v2-card-subheader.component.html',
  styleUrls: ['v2-card-subheader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2CardSubheader {}
